<template>
  <div class="show-preview">
    <div class="preview-item" v-for="preview in previews" :key="preview.id">
      <div class="preview-box"
        :style="{width: preview.w + 'px', height: preview.h + 'px', zoom: 180/preview.w}"
        @click="show(preview.id)"
      >
        <div :style="preview.div">
          <img class="cropper-preview" :src="preview.url" :style="preview.img">
        </div>
      </div>
      <a-popconfirm
        title="确定要删除此张设计图吗?"
        ok-text="确定"
        cancel-text="取消"
        @confirm="remove(preview.id)"
        @cancel="cancel"
      >
        <a-button class="remove" type="danger" shape="circle" icon="close" size="small" />
      </a-popconfirm>
    </div>
    <div class="add" style="text-align:center;margin-bottom:20px">
      <a-button shape="circle" type="icon" icon="plus" @click="$emit('add')" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      previews: []
    }
  },
  created () {
  },
  methods: {
    update (preview) {
      const i = this.previews.findIndex(x => x.id === preview.id)
      if (i >= 0) {
        this.previews[i] = preview
      } else {
        this.previews.push(preview)
      }
      this.$forceUpdate()
    },
    show (id) {
      this.$emit('show-canvas', id)
    },
    remove (id) {
      console.log(id, this.previews)
      this.$emit('remove-canvas', id)
      // 删除预览
      const i = this.previews.findIndex(x => x.id === id)
      this.previews.splice(i, 1)
    },
    cancel () {}
  }
}
</script>

<style scoped>
.show-preview{padding:10px 8px;height: 100%;overflow:hidden;}
.preview-item{position: relative;}
.preview-box{overflow: hidden; margin:0 0 15px 0;outline:3px solid #fff;}
.preview-item .remove{position:absolute;top:0;right: 0;visibility:hidden;}
.preview-item:hover .remove{visibility: visible;}
</style>



// WEBPACK FOOTER //
// src/pages/design/SideNav.vue